import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import APIKit from "../../Middleware/axiosConfig";

// API End Points
import { API_END_POINTS } from "../../Middleware/apiEndpoints";

//utils
import { notifyError } from "Services/Utils/toastNotification";


// API calls

export const fetchCompanyManagementCompany = createAsyncThunk("fetchUserManagementCompany", async ({data, callBack}) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.companyManagementCompanies}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    console.log(
      `Error ===> ${API_END_POINTS.companyManagementCompanies} ====> ${JSON.stringify(
        response?.message
      )}`
    );
  }
  return response?.data;
});
export const fetchCompanyManagementIndustry = createAsyncThunk("fetchCompanyManagementIndustry", async ({data, callBack}) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.companyManagementIndustries}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    console.log(
      `Error ===> ${API_END_POINTS.companyManagementIndustries} ====> ${JSON.stringify(
        response?.message
      )}`
    );
  }
  return response?.data;
});
export const fetchCompanyUsers = createAsyncThunk("fetchCompanyUsers", async ({data, callBack}) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.companyUsersList}/${data.id}?order_by=${data.order_by}&sort_by=${data.sort_by}&page=${data.page}&limit=${data.limit}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    console.log(
      `Error ===> ${API_END_POINTS.companyUsersList} ====> ${JSON.stringify(
        response?.message
      )}`
    );
  }
  return response?.data;
});
export const fetchCompaniesList = createAsyncThunk("fetchCompaniesList", async ({data, callBack}) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.companyList}?search=${data.search}&page=${data.page}&limit=${data.limit}&sort_by=${data.sort_by}&order_by=${data.order_by}&company_type_id=${data?.companyId}&industry_id=${data?.industryId}`);
  if (response?.status === 200 || response?.status === 400) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    console.log(
      `Error ===> ${API_END_POINTS.companyList} ====> ${JSON.stringify(
        response?.message
      )}`
    );
  }
  return response?.data;
});

export const exportAllCompaniesList = createAsyncThunk("exportAllCompaniesList", async ({data, callBack}) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.companiesList}`, {responseType : "blob"});
  if (response?.status === 200 || response?.status === 400) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    console.log(
      `Error ===> ${API_END_POINTS.companiesList} ====> ${JSON.stringify(
        response?.message
      )}`
    );
  }
  return response?.data;
});

export const fetchIndividualCompany = createAsyncThunk("fetchIndividualCompany", async ({data,callBack}) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.individualCompany}/${data.id}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.individualCompany} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const fetchCompanyServiceHistory = createAsyncThunk("fetchCompanyServiceHistory", async ({data,callBack}) => {
  // api hit
  const { id, smart_support, fromDate, toDate, sortOrder  } = data;

  let queryParams = [];

  if (smart_support) {
    queryParams.push(`smart_support_id=${smart_support}`);
  }
  if (fromDate) {
    queryParams.push(`startDate=${fromDate}T00:00:00`);
  }
  if (toDate) {
    queryParams.push(`endDate=${toDate}T23:59:59`);
  }
  if (sortOrder) {
    queryParams.push(`sortOrder=${sortOrder}`);
  }

  const queryString = queryParams.length ? `?${queryParams.join('&')}` : '';

  const response = await APIKit().get(
    `${API_END_POINTS.companyServiceHistory}/${id}${queryString}`
  );
  // const response = await APIKit().get(`${API_END_POINTS.companyServiceHistory}/${data.id}?smart_support_id=${data.company_id}&startDate=${data.fromDate}T00:00:00&endDate=${data.toDate}T23:59:59&sortOrder=DESC`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.companyServiceHistory} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const fetchCompanySubscription = createAsyncThunk("fetchCompanySubscription", async ({data,callBack}) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.subscription}/${data.id}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.subscription} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const fetchCompanyPurchaseHistory = createAsyncThunk("fetchCompanyPurchaseHistory", async ({data,callBack}) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.companyPurchaseHistory}?page=${data?.page}&limit=${data?.limit}&company_id=${data?.id}`);
  if (response?.status === 200 ) {
    callBack(response?.data);
  } 
  else if (response?.status === 400 ) {
    callBack(response);
  } 
  else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.companyPurchaseHistory} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const deleteCompany = createAsyncThunk("deleteCompany", async ({data,callBack}) => {
  // api hit
  const response = await APIKit().delete(`${API_END_POINTS.deleteCompany}/${data.id}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.deleteCompany} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const updateCompanyStatus = createAsyncThunk("updateCompanyStatus", async ({data,callBack}) => {
  // api hit
  const response = await APIKit().put(`${API_END_POINTS.companyStatusChange}/${data.status}/${data.id}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.companyStatusChange} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const editUser = createAsyncThunk("editUser", async ({data,callBack}) => {
  // api hit
  const response = await APIKit().put(`${API_END_POINTS.editUser}`,data);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.editUser} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const addCredit = createAsyncThunk("addCredit", async ({data,callBack}) => {
  // api hit
  const response = await APIKit().put(`${API_END_POINTS.editCompany}`,data);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.editCompany} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const checkEmail = createAsyncThunk("checkEmail", async ({data,callBack}) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.checkEmail}?email=${data.mail}&mobile=${data.mobile}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.checkEmail} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const mapExistingUser = createAsyncThunk("mapExistingUser", async ({data,callBack}) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.mapExistingUser}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.mapExistingUser} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const addCompany = createAsyncThunk("addCompany", async ({data,callBack}) => {
  // api hit
  const response = await APIKit().post(`${API_END_POINTS.addCompany}`,data);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.addCompany} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const editCompany = createAsyncThunk("editCompany", async ({data,callBack}) => {
  // api hit
  const response = await APIKit().put(`${API_END_POINTS.editUserCompany}`,data);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.editUserCompany} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const manageUsersDataFetch = createAsyncThunk("manageUsersDataFetch", async ({data,callBack}) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.manageUsersCM}/${data.companyID}?page=${data.page}&limit=${data.limit}&sort_by=${data.sort_by}&order_by=${data.order_by}`);
  if (response?.status === 200 || 400) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.manageUsersCM} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const manageUsersSendInvite = createAsyncThunk("manageUsersSendInvite", async ({data,callBack}) => {
  // api hit
  const response = await APIKit().post(`${API_END_POINTS.sendInvite}?user_id=${data.id}&email=${data.email}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.sendInvite} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});


 export const companyManagementSlice = createSlice({
  name: "companyManagement",
  initialState: { isLoading: false },
  reducers: {},
  extraReducers: (builder) => {

    builder
      .addCase(fetchCompanyManagementCompany.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchCompanyManagementCompany.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchCompanyManagementCompany.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchCompanyManagementIndustry.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchCompanyManagementIndustry.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchCompanyManagementIndustry.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchCompanyUsers.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchCompanyUsers.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchCompanyUsers.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchCompaniesList.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchCompaniesList.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchCompaniesList.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchIndividualCompany.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchIndividualCompany.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchIndividualCompany.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchCompanyServiceHistory.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchCompanyServiceHistory.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchCompanyServiceHistory.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchCompanySubscription.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchCompanySubscription.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchCompanySubscription.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchCompanyPurchaseHistory.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchCompanyPurchaseHistory.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchCompanyPurchaseHistory.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(deleteCompany.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(deleteCompany.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(deleteCompany.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(updateCompanyStatus.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(updateCompanyStatus.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(updateCompanyStatus.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(editUser.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(editUser.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(editUser.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(addCredit.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(addCredit.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(addCredit.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(checkEmail.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(checkEmail.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(checkEmail.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(mapExistingUser.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(mapExistingUser.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(mapExistingUser.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(manageUsersDataFetch.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(manageUsersDataFetch.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(manageUsersDataFetch.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(addCompany.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(addCompany.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(addCompany.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(editCompany.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(editCompany.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(editCompany.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(manageUsersSendInvite.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(manageUsersSendInvite.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(manageUsersSendInvite.rejected, (state, action) => {
        state.isLoading = "failed";
      });

  },
});

export default companyManagementSlice.reducer;
